import React, { useEffect,useContext, useState } from 'react';
import cl from './DealerCarPage.module.css';
import Arrow from "../../../../assets/Icon/Arrow"; 
import { useCar } from '../../../../hooks/useCar';
import { baseFileURL } from '../../../../Api';
import ContainerLogo from '../../../../assets/Logo/ContainerLogo';
import DealerCarPhotos from './DealerCarPhotos';
import AddClient from './AddClient';
import DealerComision from './DealerComision';
import AIG from '../../../../assets/Logo/AIG';
import Automoby from '../../../../assets/Logo/Automoby';
import Vin from "../../../../assets/Icon/Vin";
import { useTranslation } from 'react-i18next';
import Auction from "../../../../assets/Icon/Auction"; 
import Flag from '../../../UI/Flag/Flag'; 
import Calendar from "../../../../assets/Icon/Calendar";
import Ship from "../../../../assets/Icon/Ship";
import Container from "../../../../assets/Icon/Container";
import Barcode from "../../../../assets/Icon/Barcode";
import Car from "../../../../assets/Icon/Car";
import BLicon from "../../../../assets/Icon/BLicon"; 
import NumberIcon from "../../../../assets/Icon/Number";
import Client from "../../../../assets/Icon/User";
import Mobile from "../../../../assets/Icon/Mobile";
import Id from "../../../../assets/Icon/Id";
import At from "../../../../assets/Icon/At";
import USD from "../../../../assets/Icon/USD";
import Earth from "../../../../assets/Icon/Earth"; 
import AutowiniInvoice from '../Invoice/AutowiniInvoice';
import LondonUnderWriters from '../LondonUnderwriters/Underwriters'; 
import Contract from '../Contract/Contract'; 
import InsuranceSupplement from '../Contract/InsuranceSupplement';
import PrivacyPolicy from '../Contract/PrivacyPolicy';
import ContractDeposit from '../Contract/Deposit'; 
import AddIdCard from './AddIdCard'; 


const DealerCarPage = ({ id }) => {
    const { t, i18n } = useTranslation();
    const lang = i18n.language;     

    const { carService } = useCar(-1);
    const [car, setCar] = useState(null);   
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
  

    const formatDate = (dateString) => {
        if (!dateString) {
            return "";
        }

        const purchasedAtDate = new Date(dateString);

        if (isNaN(purchasedAtDate.getTime())) {
            //console.error("Invalid date provided:", dateString);
            return "";
        }

        const months = [
            t('Jan'), t('Feb'), t('Mar'), t('Apr'), t('May'), t('Jun'),
            t('Jul'), t('Aug'), t('Sep'), t('Oct'), t('Nov'), t('Dec')
        ];

        const monthIndex = purchasedAtDate.getMonth();
        if (typeof monthIndex !== "number" || monthIndex < 0 || monthIndex > 11) {
            return "";
        }

        const day = purchasedAtDate.getDate();
        const month = months[monthIndex];
        const year = purchasedAtDate.getFullYear();

        return `${day} ${month} ${year}`;
    };
 

 
    useEffect(() => {
        const fetchCarImages = async () => {
            try {
                const fetchedCar = await carService.getCarPhotosById(Number(id));
                if (fetchedCar) {
                    setCar(fetchedCar);   
                } else {
                    setError("No car found with the given ID.");
                }
            } catch (err) {
                setError(`Error fetching car details: ${err.message}`);
                console.error("Error fetching the car:", err);
            } finally {
                setIsLoading(false);
            }
        };

        if (id) {
            fetchCarImages();
        }
    }, [id]);


 
    const prices = car ? carService.calculatePrice(car) : null;
    const percent = prices?.clientPercent ?? 0;
    const clientPrice = prices?.clientPrice ?? 0; 

    if (isLoading) {
        return <div>Loading item...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }
 
    const handleBack = () => {
        if (window.history.length > 1) {
            window.history.back();
        } else { 
            window.location.href = '/';
        }
    };

 
    return (
        <div className={cl.main}>
            <div className={cl.container}>
                <div className={cl.head}>
                    <div className={cl.h1}> 
                        <span className={cl.backLink} onClick={handleBack}>
                            <Arrow />
                        </span>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div style={{ lineHeight: 1, fontSize: 14, fontWeight: 600 }}>
                                {car.prod_year && car.prod_year} {car.maker && car.maker.name} {car.model && car.model.name}
                            </div>
                            {car && (
                                <div style={{ lineHeight: 1, fontSize: 14, fontWeight: 600, marginTop: 3 }}>
                                    {car.vin !== undefined ? car.vin : ''}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className={ 
                        baseFileURL === "https://finance.automoby.ge" 
                        ? cl.logo + ' ' + cl.automoby 
                        : baseFileURL === "https://crm.aig.com.ge" 
                        ?  cl.logo + ' ' + cl.AIG 
                        : baseFileURL === "https://i-logistics.net" 
                        ?  cl.logo + ' ' + cl.containers 
                        : "" 
                    } >
                        {
                            baseFileURL === "https://finance.automoby.ge" 
                            ?  <Automoby  />   
                            : baseFileURL === "https://crm.aig.com.ge" 
                            ?  <AIG  />  
                            : baseFileURL === "https://i-logistics.net" 
                            ? <div className={cl.LogoContainer}>
                                <ContainerLogo  />
                                <span>i-Logistics</span>  
                            </div> 
                            : "" 
                        }  
                    </div>
                </div>

                <div className={cl.row}>
                    <div className={cl.col +' '+ cl.col4}>
                        <DealerCarPhotos carService={carService} car={ car }/>
                    </div>
                    <div className={cl.col +' '+ cl.col8}> 
                        <div className={cl.boxMainInfo}> 

                            <div className={cl.row0p  } style={{ margin: 0 }}>
                                <div className={cl.col +" "+cl.col6}>
    
                                    <div className={cl.incar }  style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.15)'  }} > 
                                        <div className={cl.carDesc}>
                                            <div className={cl.carName}>
                                                {car.prod_year && car.prod_year} {car.maker && car.maker.name} {car.model && car.model.name}
                                            </div>
                                            <div className={cl.carDetail}>
                                                <ul>
                                                    <li>
                                                        <span>{t('Manufacturer')}</span>
                                                        <span><Car /> {car.maker && car.maker.name}</span>
                                                    </li>
                                                    <li>
                                                        <span>{t('Model')}</span>
                                                        <span><Barcode /> {car.model && car.model.name}</span>
                                                    </li>
                                                    <li>
                                                        <span>{t('Year')}</span>
                                                        <span><NumberIcon />{car.prod_year}</span>
                                                    </li>
                                                    <li>
                                                        <span>{t('VINCode')}</span>
                                                        <span><Vin />{car.vin}</span>
                                                    </li>
                                                    <li>
                                                        <span>{t('PurchaseDate')}</span>
                                                        <span><Calendar />{formatDate(car.purchased_at)}</span>
                                                    </li> 
                                                    <li>
                                                        <span>{t('WebSite')}</span>
                                                        <span><Earth />{car.website.name}</span>
                                                    </li>  
                                                    <li>
                                                        <span>{t('LotNumber')}</span>
                                                        <span><Auction />{car.lot}</span>
                                                    </li> 
                                                </ul>
                                                
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className={cl.col +" "+cl.col6}>

                                    <div className={cl.incar + ' ' + cl.incarTransport}> 
                                        <div className={cl.carDesc}>
                                            <div className={cl.carName}>
                                               {t('Transportation')}
                                            </div>
                                            <div className={cl.carDetail}>
                                                
                                                <ul> 
                                                    <li>
                                                        <span>{t('InitialLocation')}</span>
                                                        <span>
                                                            {car.transport_price && car.transport_price.location_country ? (
                                                                <Flag countryCode={car.transport_price.location_country.code}> </Flag>
                                                            ) : (
                                                            ''
                                                            )} {car?.transport_price?.location_city?.name}, {car?.transport_price?.location_country?.name}
                                                        </span>
                                                    </li>
                                                    <li>
                                                        <span>{t('ReceivingPort')}</span>
                                                        <span>
                                                            <Flag countryCode={car.reciever_country && car.reciever_country.code}> </Flag> {car?.reciever_city?.name}, {car?.reciever_country?.name}
                                                        </span>
                                                    </li> 
                                                    <li>
                                                        <span>{t('SendAt')}</span>
                                                        <span>
                                                            <Calendar/> {car.sender_at ? formatDate(car.sender_at) : '- - -'}
                                                        </span>
                                                    </li> 
                                                    <li>
                                                        <span>{t('ReceivedAt')}</span>
                                                        <span>
                                                            <Calendar/> {car.reciever_at ? formatDate(car.reciever_at) : '- - -'}
                                                        </span>
                                                    </li>  
                                                    <li>
                                                        <span>{t('MarineLine')}</span>
                                                        <span>
                                                            <Ship/> {car.marine_line?.name ? car.marine_line.name : '- - -'}
                                                        </span>
                                                    </li> 
                                                    <li>
                                                        <span>{t('Container')}</span>
                                                        <span>
                                                            <Container />  {car.container_number ? car.container_number : '- - -' }
                                                        </span>  
                                                    </li> 
                                                    <li>
                                                        <span>{t('BLNumber')}</span>
                                                        <span>
                                                            <BLicon /> {car.bl_number ? car.bl_number : '- - -' }
                                                        </span>  
                                                    </li> 
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div className={cl.row0p  } style={{ margin: 0 }}>
                               
                                <div className={cl.col +" "+cl.col6}>
  
                                    <div className={cl.incar }> 
                                        <div className={cl.carDesc}>
                                            <div className={cl.carName}>
                                               {t('Client')} 
                                               {!car.client && <AddClient id={car.id} carService={carService} car={car} />}
                                            </div>
                                            <div className={cl.carDetail}>
                                                <ul> 
                                                    <li>
                                                        <span>{t('Client')}</span>
                                                        <span><Client/> {car.client && car.client.firstname} {car.client && car.client.lastname}</span> 
                                                    </li>  
                                                    <li>
                                                        <span>{t('PersonalNumber')}</span>
                                                        <span><Id/> {car.client && car.client.personal}  </span> 
                                                    </li>  
                                                    <li>
                                                        <span>{t('Mobile')}</span>
                                                        <span><Mobile/> {car.client && car.client.mobile}  </span> 
                                                    </li>  
                                                    <li>
                                                        <span>{t('Email')}</span>
                                                        <span><At/> {car.client && car.client.email}  </span> 
                                                    </li>  
                                                </ul>
 
                                            </div>
                                            <div className={cl.carDetail}>
                                                {car.client ? (

                                                    <ul> 
                                
                                                        <li> 
                                                            <span style={{ maxWidth: '80px'}}>{t('IDFront')}</span>
                                                            <span><Id />
                                                                    {car.client.id_front ? (
                                                                    <a href={car.client.id_front} target="_blank" rel="noopener noreferrer"> {t('Front')} </a>
                                                                    ) : null}

                                                                    

                                                            </span>
                                                            {!car.client.id_front && ( 
                                                                <AddIdCard defaultUser={car.client} />
                                                            )}  
                                                        </li>
                                                        <li> 
                                                            <span style={{ maxWidth: '80px'}}>{t('IDBack')}</span>
                                                            <span><Id />
                                                            {car.client.id_back ? (
                                                                    <a href={car.client.id_back} target="_blank" rel="noopener noreferrer"> {t('Back')} </a>
                                                                    ) : null}

                                                                    
                                                            </span>
                                                            {!car.client.id_back && (
                                                                <AddIdCard defaultUser={car.client} />
                                                            )}  
                                                        </li>

    
                                                    </ul>

                                                
                                                ) : null}

                                            </div>

                                            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', 'gap': '5px 7px', marginTop: '40px' }}>

 
                                                {baseFileURL === 'https://finance.automoby.ge' ? 
                                                    ((car.client_price_fund * car.client_percent_fund) / 100 > 0 ?
                                                    car.fund_accept == 1 ?
                                                        <AutowiniInvoice  greenStyle={true} carItem={car} discountAccept={car.discount_accept}  websiteItem={car.website} clientItem={car.client} />
                                                    :
                                                        ''
                                                    :
                                                    <AutowiniInvoice greenStyle={true} carItem={car} discountAccept={car.discount_accept}  websiteItem={car.website} clientItem={car.client} />)
                                                :
                                                ((car.client_price_fund * car.client_percent_fund) / 100 > 0 ?
                                                car.fund_accept == 1 ?
                                                    <AutowiniInvoice greenStyle={true} carItem={car} discountAccept={car.discount_accept}  websiteItem={car.website} clientItem={car.client} />
                                                :
                                                    ''
                                                :
                                                    <AutowiniInvoice greenStyle={true} carItem={car} discountAccept={car.discount_accept}  websiteItem={car.website} clientItem={car.client} />)
                                                }
                                                {car.website.id === 5 ? <ContractDeposit carItem={car} /> : <Contract carItem={car} />}
                                                <LondonUnderWriters carItem={car} />
                                                <InsuranceSupplement carItem={car} />
                                                <PrivacyPolicy carItem={car} />
 

                                            </div>
                                        </div>
                                    </div>

                                  
                                </div>

                                <div className={cl.col +" "+cl.col6}>
    
                                    <div className={cl.incar + ' ' + cl.incarFinancial}> 
                                        <div className={cl.carDesc}>
                                            <div className={cl.carName}>
                                                {t('FinancialInformation')}
                                            </div>
                                            <div className={cl.carDetail}>
                                                <ul> 
                                                    {car.client_price_car > 0 && (
                                                        <li><span>{t('CostoftheCar')}</span><span><USD /> {car.client_price_car}</span></li>
                                                    )} 

                                                    {(car.client_price_transport + car.client_price_internal) > 0 && (
                                                        <li> <span>{t('TransportationCost')}</span><span><USD /> {car.client_price_transport + car.client_price_internal}</span></li>
                                                    )} 
                                                 
                                                    {percent > 0 && (
                                                        <li> <span>{t('Procent')}</span><span><USD /> {percent}</span></li>
                                                    )} 
                                                        <li> 
                                                            <span>{t('DealerCommissionCar')}</span>
                                                            <span><USD /> {car.client_price_dealer} </span>
                                                            {car.client_price_dealer === 0 && (
                                                                 <DealerComision id={car.id} field="client_price_dealer" />
                                                            )}  
                                                        </li>
                                                        <li> 
                                                            <span>{t('DealerCommissionTransport')}</span>
                                                            <span><USD /> {car.client_price_dealer_transport} </span>
                                                            {car.client_price_dealer_transport === 0 && (
                                                                 <DealerComision id={car.id} field="client_price_dealer_transport" />
                                                            )}  
                                                        </li>
                                                    {car.client_price_document > 0 && (
                                                        <li> <span>{t('DocumentPrice')}</span><span><USD /> {car.client_price_document} </span></li>
                                                    )} 
                                                    {car.client_price_insurance > 0 && (
                                                        <li> <span>{t('Insurance')}</span><span><USD /> {car.client_price_insurance} </span></li>
                                                    )}  
                                                    {car.client_price_penalty > 0 && (
                                                        <li> <span>{t('Penalty')}</span><span><USD /> {car.client_price_penalty} </span></li>
                                                    )} 
                                                    {car.client_price_transfer_fee > 0 && (
                                                        <li> <span>{t('TransferFee')}</span><span><USD /> {car.client_price_transfer_fee} </span></li>
                                                    )} 
                                                    {car.client_price_inspection > 0 && (
                                                        <li> <span>{t('Inspection')}</span><span><USD /> {car.client_price_inspection} </span></li>
                                                    )}
                                                    {car.client_price_fund > 0 && (
                                                        <li> <span>{t('RequestedAmount')}</span><span><USD /> {car.client_price_fund} </span></li>
                                                    )} 
                                                    {car.client_price_discount > 0 && (
                                                        <li> <span>{t('Discount')}</span><span><USD /> {car.client_price_discount} </span></li>
                                                    )}  

                                                    <div style={{ marginTop: '10px', marginBottom: '10px', height: '1px', width: '100%', background: 'rgba(0, 0, 0, 0.15)' }}></div>

                                                        <li> <span>{t('Total')}</span><span><USD />{clientPrice}</span></li> 
                                                        <li> <span>{t('Debt')}</span><span><USD />{car.client_debt}</span></li>
                                                        <li> <span>{t('AmountPaid')}</span><span><USD />{car.total_client_paid}</span></li>
                                                     
                                                </ul>
                                            </div> 
                                        </div>
                                    </div>
 
                                </div>
                                

                            </div>




                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DealerCarPage;
